export type ColorType = "Primary" | "Success" | "Warning" | "Error";
export const Colors: Record<ColorType, string> = {
  Primary: "#17a2b8", // blue
  Success: "#52c41a", // green
  Warning: "#faad14", // orange
  Error: "#ff4d4f", // red
};
